export interface IHttpResponse<T> extends Response {
  parsedBody?: T;
}

class LocatorServices {

  getPoints = <T>(request: RequestInfo, postalCode?: string): Promise<IHttpResponse<T>> => {
    return new Promise((resolve, reject) => {
      let response: IHttpResponse<T>;
      const endPoint = postalCode ? `${request}&address=${postalCode}&dealerization_postal_code=${postalCode}` : request;
      fetch(endPoint)
        .then(res => {
          response = res;
          return res.json();
        })
        .then(body => {
          if (response.ok) {
            response.parsedBody = body;
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  };

  checkIfExists = <T>(request: RequestInfo, postalCode: string): Promise<IHttpResponse<T>> => {
    return new Promise((resolve, reject) => {
      let response: IHttpResponse<T>;
      const endPoint = `${request}?address=${postalCode}`;
      fetch(endPoint)
        .then(res => {
          response = res;
          return res.json();
        })
        .then(body => {
          if (response.ok) {
            response.parsedBody = body;
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  };

}

export default LocatorServices;
